module.exports = __webpack_public_path__ + "static/media/resetIcon.00e15143.svg";